import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScaleLoader = _resolveComponent("ScaleLoader")!
  const _component_ExportButtons = _resolveComponent("ExportButtons")!
  const _component_Card = _resolveComponent("Card")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxColumnFixing = _resolveComponent("DxColumnFixing")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_ScaleLoader, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ExportButtons, {
          csv: _ctx.exportGridsToExcel,
          pdf: _ctx.exportGridsToPdf,
          xlsx: _ctx.exportGridsToExcel
        }, null, 8, ["csv", "pdf", "xlsx"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Card, {
              badges: 3,
              "info-badge-description": [_ctx.cardStore[0], _ctx.cardStore[1], _ctx.cardStore[2]],
              "info-badge-title": [_ctx.$t('components.reports.eventsList.totalDistance'), _ctx.$t('components.reports.eventsList.drivingTime'), _ctx.$t('components.reports.eventsList.breakTime')],
              status: _ctx.$t('components.history.tabs.routeReport'),
              icon: "bi bi-route"
            }, null, 8, ["info-badge-description", "info-badge-title", "status"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_DxDataGrid, {
            ref: _ctx.hiddenDataGridRef,
            "data-source": _ctx.store.details,
            style: {"display":"none"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxColumn, {
                caption: _ctx.$t('components.history.tabs.routeReport')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxColumn, {
                    "allow-filtering": true,
                    "allow-header-filtering": false,
                    caption: _ctx.$t('components.reports.eventsList.totalDistance'),
                    "filter-operations": _ctx.allowedOperations,
                    "data-field": "full_distance"
                  }, null, 8, ["caption", "filter-operations"]),
                  _createVNode(_component_DxColumn, {
                    "allow-filtering": true,
                    "allow-header-filtering": false,
                    caption: _ctx.$t('components.reports.eventsList.drivingTime'),
                    "filter-operations": _ctx.allowedOperations,
                    "data-field": "drive_time"
                  }, null, 8, ["caption", "filter-operations"]),
                  _createVNode(_component_DxColumn, {
                    "allow-filtering": true,
                    "allow-header-filtering": false,
                    caption: _ctx.$t('components.reports.eventsList.breakTime'),
                    "filter-operations": _ctx.allowedOperations,
                    "data-field": "rest_time"
                  }, null, 8, ["caption", "filter-operations"])
                ]),
                _: 1
              }, 8, ["caption"])
            ]),
            _: 1
          }, 8, ["data-source"]),
          _createVNode(_component_DxDataGrid, {
            ref: _ctx.dataGridRef,
            "allow-column-reordering": true,
            "allow-column-resizing": true,
            "column-auto-width": true,
            "column-hiding-enabled": true,
            "data-source": _ctx.store.events_list,
            "hover-state-enabled": true,
            "remote-operations": _ctx.remoteOperations,
            "row-alternation-enabled": true,
            "show-borders": true,
            "show-column-lines": true,
            "show-row-lines": false,
            class: "route-report-grid"
          }, {
            startLocationTemplate: _withCtx(({ data }) => [
              _createElementVNode("a", {
                href: _ctx.generateGoogleMapsLink(data.data.place_start),
                target: "_blank",
                class: "location-link"
              }, _toDisplayString(_ctx.getLocationText(data.data, 'start')), 9, _hoisted_5)
            ]),
            stopLocationTemplate: _withCtx(({ data }) => [
              _createElementVNode("a", {
                href: _ctx.generateGoogleMapsLink(data.data.place_stop),
                target: "_blank",
                class: "location-link"
              }, _toDisplayString(_ctx.getLocationText(data.data, 'stop')), 9, _hoisted_6)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_DxHeaderFilter, { visible: true }),
              _createVNode(_component_DxPaging, {
                "page-index": 0,
                "page-size": 25
              }),
              _createVNode(_component_DxPager, {
                "allowed-page-sizes": [10, 20, 25],
                "show-info": true,
                "show-navigation-buttons": true,
                "show-page-size-selector": true
              }),
              _createVNode(_component_DxFilterRow, { visible: true }),
              _createVNode(_component_DxColumnFixing, { enabled: true }),
              _createVNode(_component_DxColumn, {
                caption: _ctx.$t('components.history.tabs.routeReport')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxColumn, {
                    "allow-filtering": true,
                    "allow-header-filtering": false,
                    caption: _ctx.$t('components.reports.eventsList.start'),
                    "filter-operations": _ctx.allowedOperations,
                    "data-field": "start_timestamp"
                  }, null, 8, ["caption", "filter-operations"]),
                  _createVNode(_component_DxColumn, {
                    "allow-filtering": true,
                    "allow-header-filtering": false,
                    caption: _ctx.$t('components.reports.eventsList.stop'),
                    "filter-operations": _ctx.allowedOperations,
                    "data-field": "stop_timestamp"
                  }, null, 8, ["caption", "filter-operations"]),
                  _createVNode(_component_DxColumn, {
                    "allow-filtering": true,
                    "allow-header-filtering": false,
                    caption: _ctx.$t('components.reports.ignition.ignition'),
                    "filter-operations": _ctx.allowedOperations,
                    "data-field": "ignition"
                  }, null, 8, ["caption", "filter-operations"]),
                  _createVNode(_component_DxColumn, {
                    "allow-filtering": true,
                    "allow-header-filtering": false,
                    caption: _ctx.$t('components.reports.eventsList.time'),
                    "filter-operations": _ctx.allowedOperations,
                    "data-field": "time"
                  }, null, 8, ["caption", "filter-operations"]),
                  _createVNode(_component_DxColumn, {
                    "allow-filtering": true,
                    "allow-header-filtering": false,
                    caption: _ctx.$t('components.reports.eventsList.distance'),
                    "filter-operations": _ctx.allowedOperations,
                    "data-field": "distance"
                  }, null, 8, ["caption", "filter-operations"]),
                  _createVNode(_component_DxColumn, {
                    "allow-filtering": true,
                    "allow-header-filtering": false,
                    caption: _ctx.$t('components.history.routeReport.startLocation'),
                    "filter-operations": _ctx.allowedOperations,
                    "data-field": "place_start_link",
                    "allow-sorting": false,
                    "cell-template": "startLocationTemplate"
                  }, null, 8, ["caption", "filter-operations"]),
                  _createVNode(_component_DxColumn, {
                    "allow-filtering": true,
                    "allow-header-filtering": false,
                    caption: _ctx.$t('components.history.routeReport.stopLocation'),
                    "filter-operations": _ctx.allowedOperations,
                    "data-field": "place_stop_link",
                    "allow-sorting": false,
                    "cell-template": "stopLocationTemplate"
                  }, null, 8, ["caption", "filter-operations"])
                ]),
                _: 1
              }, 8, ["caption"])
            ]),
            _: 1
          }, 8, ["data-source", "remote-operations"])
        ])
      ]))
}